const getPriorityWiseValidationList = (validations) => {
  const priorityWiseValidationList = validations.sort(
    (prevElement, nextElement) => {
      return prevElement.priority - nextElement.priority;
    }
  );
  return priorityWiseValidationList;
};

const validateRequiredValidation = (value) => {
  return value && value.toString().length ? false : true;
};

const validateMinLengthValidation = (value, minLength) => {
  return value ? (value.toString().length >= minLength ? false : true) : false;
};

const validateMaxLengthValidation = (value, maxLength) => {
  return value ? (value.toString().length <= maxLength ? false : true) : false;
};

const validateRegexValidation = (value, regex) => {
  return value ? (value.match(regex) ? false : true) : false;
};

const validateMinValueValidation = (value, minValue) => {
  return value ? (+value >= minValue ? false : true) : false;
};

const validateMaxValueValidation = (value, maxValue) => {
  return value ? (+value <= maxValue ? false : true) : false;
};

const validateIsNumberValidation = (value) => {
  return value ? (typeof value === "number" ? false : true) : false;
};

const isValidationFailed = (value, validation) => {
  switch (validation.validationName) {
    case "required":
      return validateRequiredValidation(value);
    case "minLength":
      return validateMinLengthValidation(value, validation.value);
    case "maxLength":
      return validateMaxLengthValidation(value, validation.value);
    case "isNumber":
      return validateIsNumberValidation(value, validation.value);
    case "minValue":
      return validateMinValueValidation(value, validation.value);
    case "maxValue":
      return validateMaxValueValidation(value, validation.value);
    case "regex":
      return validateRegexValidation(value, validation.value);
    default:
      return false;
  }
};

const getFailedValidation = (value, validations) => {
  const failedValidation = validations.find((validation) => {
    return isValidationFailed(value, validation);
  });
  return failedValidation;
};

var password = (function () {
  var state;
  var pub = {};

  pub.changeState = function (newstate) {
    state = newstate;
  };

  pub.getState = function () {
    return state;
  };

  return pub;
})();

const confirmPasswordValidation = (name, value) => {
  let confirmPassword;

  if (name === "password" || name === "new_password")
    password.changeState(value);
  if (name === "confirm_password" || name === "confirm_new_password")
    confirmPassword = value;

  if (password.getState() === confirmPassword) return "";
  else if (name === "confirm_password" || name === "confirm_new_password")
    return "Password doesn't match";
};

export const validateTextField = (
  value,
  validations,
  isFormSubmitted,
  validate,
  name,
  isTextFieldDirty
) => {
  let validationMessage = "";
  const shouldErrorMessageShown = isTextFieldDirty || isFormSubmitted;

  const priorityWiseValidationList = getPriorityWiseValidationList(validations);
  const failedValidation = getFailedValidation(
    value && value.trim && value.trim(),
    priorityWiseValidationList
  );
  if (failedValidation) {
    validationMessage = failedValidation.message;
  } else {
    validationMessage = confirmPasswordValidation(name, value);
  }

  return { validationMessage, shouldErrorMessageShown };
};

export const getFormsValidityStatus = (formStatusobj) => {
  let isFormValid = true;
  for (var key in formStatusobj) {
    if (formStatusobj?.key) {
      isFormValid = isFormValid && formStatusobj[key];
    }
  }
  return isFormValid;
};
